import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, withCtx as _withCtx, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-55f378f8")

_pushScopeId("data-v-55f378f8")
const _hoisted_1 = {
  class: "trigger-message",
  id: "trigger-preview"
}
const _hoisted_2 = { class: "message-wrap slow-showing-animation" }
const _hoisted_3 = {
  id: "content",
  class: "fit"
}
const _hoisted_4 = {
  key: 1,
  class: "buttons slow-showing-animation"
}
const _hoisted_5 = {
  key: 2,
  class: "q-mb-xl"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_trigger_message_content_wrap = _resolveComponent("trigger-message-content-wrap")
  const _component_bubbles = _resolveComponent("bubbles")
  const _component_q_input = _resolveComponent("q-input")
  const _component_select_chanel_refactor = _resolveComponent("select-chanel-refactor")
  const _component_answer_button = _resolveComponent("answer-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("span", _hoisted_2, [
      (_ctx.isLastMessage)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            icon: "close",
            class: "close-button slow-showing-animation",
            round: true,
            size: "12px",
            color: "white",
            "text-color": "darkgrey",
            padding: "2px",
            onClick: _withModifiers(_ctx.closePreviewTrigger, ["stop"])
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.messagesContent, (messageContent, index) => {
        return (_openBlock(), _createBlock(_component_trigger_message_content_wrap, {
          key: index,
          isFirst: index === 0,
          message: messageContent,
          onLoaded: _ctx.updateSizeIframe
        }, null, 8, ["isFirst", "message", "onLoaded"]))
      }), 128 /* KEYED_FRAGMENT */)),
      (_ctx.isShowBubbles)
        ? (_openBlock(), _createBlock(_component_bubbles, {
            key: 1,
            class: "slow-showing-animation"
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isShowAnswerField && _ctx.isLastMessage && !_ctx.message.buttons)
      ? (_openBlock(), _createBlock(_component_q_input, {
          key: 0,
          modelValue: _ctx.text,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.text = $event)),
          type: "text",
          label: _ctx.$t('widgetEnterMessage'),
          outlined: true,
          dense: true,
          class: "input slow-showing-animation",
          "bg-color": "white",
          onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.inputValue()), ["enter"]))
        }, _createSlots({ _: 2 }, [
          (_ctx.text)
            ? {
                name: "append",
                fn: _withId(() => [
                  _createVNode(_component_q_btn, {
                    icon: "send",
                    flat: true,
                    dense: true,
                    round: true,
                    color: "primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputValue()))
                  })
                ])
              }
            : undefined
        ]), 1032, ["modelValue", "label"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      (_ctx.message.question_type === 'select_channel')
        ? (_openBlock(), _createBlock(_component_select_chanel_refactor, {
            key: 0,
            "display-type": "trigger",
            message: _ctx.message,
            "respondent-id": _ctx.respondentId,
            onSendMessage: _ctx.sendMessage,
            class: "buttons"
          }, null, 8, ["message", "respondent-id", "onSendMessage"]))
        : (_ctx.message.buttons && _ctx.isLastMessage)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.message.buttons, (button, index) => {
                return (_openBlock(), _createBlock(_component_answer_button, {
                  key: index,
                  button: button,
                  onClickButtonWithPayload: _ctx.sendMessage,
                  isWidget: true,
                  style: { ..._ctx.CalculaterButtonWidth(button.width) }
                }, null, 8, ["button", "onClickButtonWithPayload", "style"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_5))
    ]),
    _createVNode("button", {
      class: "hidded-avatar-button",
      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.openWidget()), ["stop"]))
    }),
    _createVNode("button", {
      class: "hidded-video-mut-button",
      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.toggleMutVideo()), ["stop"]))
    })
  ]))
})